<template>
  <div class="header">
    <div class="header_con">
      <div class="left">
        <img src="../../assets/logo.png" @click="$router.push('/home')" />
        <span class="title" @click="$router.push('/home')">青蛙恋上鱼</span>
        <span
          @click="$router.push('/home')"
          class="nav_item"
          :class="{nva_active: $route.path === '/home'}"
        >
          首页
        </span>
        <span
          @click="$router.push('/activity')"
          class="nav_item"
          :class="{nva_active: $route.path === '/activity'}"
        >
          活动
        </span>
      </div>
      <div class="right">
        <el-input
          :disabled="!($route.path === '/home' || $route.path === '/user')"
          class="input_search" clearable placeholder="搜索博客" size="mini"
          v-model="searchVal">
          <i slot="suffix" @click="searchBlog"
            class="el-input__icon el-icon-search search_icon"></i>
        </el-input>
        <el-button @click="addBlogHandel" class="add_blog" size="mini"
          type="primary">写文章</el-button>
        <el-popover class="img_popover" v-if="userInfo.username"
          v-model="popoverShow" placement="bottom" trigger="click">
          <ul class="popover_ul">
            <!-- <li v-for="item of options" :key="item.value" @click="popoverShow=false;$router.push(item.path)">{{ item.label }}</li> -->
            <li @click="addBlogHandel">写文章</li>
            <li @click="gotoUser">我的主页</li>
            <li @click="settingPassword">修改密码</li>
            <li @click="logoutHandle">退出</li>
          </ul>
          <img slot="reference"
            :src="userInfo.headImg || require('../../assets/logo.png')" />
        </el-popover>
        <el-button v-else @click="$router.push('/login')" size="mini">登录
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { logoutApi } from '@/views/apis';
import vueBus from '@/common/vueBus.js';
export default {
  data () {
    return {
      popoverShow: false,
      options: [
        { value: 'user', label: '个人中心', path: '/user?id=' + (localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}).id },
        { value: 'logout', label: '退出', path: '/login' }
      ],
      searchVal: '',
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
    };
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    gotoUser () {
      let path = '/user?id=' + (localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}).id;
      this.popoverShow = false;
      this.$router.push(path);
    },
    settingPassword () {
      this.popoverShow = false;
      this.$router.push('/password-settings');
    },
    logoutHandle () {
      logoutApi()
        .then(res => {
          if (res.errno === 0) {
            this.popoverShow = false;
            localStorage.clear();
            this.$message.success(res.message);
            this.$router.push('/login');
          }
        });
    },
    addBlogHandel () {
      this.popoverShow = false;
      if (!this.userInfo.id) {
        this.$router.push('/login');
        return;
      }
      this.$router.push('/blog-editor');
    },
    searchBlog () {
      const searchVal = this.searchVal.toLowerCase();
      console.log('searchBlog', this.$route.path);
      if (this.$route.path === '/home') {
        vueBus.$emit('searchBlogAll', searchVal);
      } else if (this.$route.path === '/user') {
        vueBus.$emit('searchBlogSelf', searchVal);
      }
    }
  }
};
</script>
<style lang="less">
.popover_ul {
  padding: 0;
  width: 160px;
  list-style: none;
  // border: 1px solid rgba(177,180,185,.45);
  li {
    display: block;
    width: 100%;
    cursor: pointer;
    box-sizing: border-box;
    padding: 10px;
    color: #71777c;
    text-decoration: none;
    &:hover {
      background: #f1f1f1;
    }
  }
}
</style>
<style lang="less" scoped>
.header {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 99;
  background: #ffffff;
  width: 100%;
  height: 60px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #f1f1f1;
  .header_con {
    width: 960px;
    display: flex;
    justify-content: space-between;
    .left,
    .right {
      display: flex;
      align-items: center;
    }
    .left {
      cursor: pointer;
      img {
        width: 38px;
        height: 38px;
      }
      .title {
        color: #007fff;
        font-size: 30px;
        margin-left: 10px;
      }
      .nav_item {
        color: #71777c;
        font-size: 16px;
        margin-left: 30px;
        cursor: pointer;
      }
      .nva_active {
        color: #007fff;
      }
    }
    .right {
      .input_search {
        width: 168px;
        .search_icon {
          cursor: pointer;
          font-size: 14px;
          &:hover {
            color: #007fff;
          }
        }
      }
      .add_blog {
        margin: 0 25px;
      }
      .img_popover {
        img {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 980px) {
  .header {
    height: 50px;
    .header_con {
      width: 100%;
      padding: 0 10px;
      .left {
        cursor: none;
        .title {
          display: none;
          // font-size: 18px;
          // margin-left: 5px;
        }
        .nav_item {
          font-size: 14px;
          margin-left: 15px;
          cursor: none;
        }
      }
      .right {
        .input_search {
          width: 118px;
          margin-right: 15px;
          // display: none;
        }
        .add_blog {
          display: none;
        }
        .img_popover {
          img {
            width: 28px;
            height: 28px;
            cursor: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue